import './articlescontainer.less'

import {action, classes, Component} from '@codeurs/front'
import m from 'mithril'
import {t} from 'store'
import Button from 'views/layout/button'
import ContainerTitle from 'views/layout/containertitle'
import ArticleLink, {ArticleType} from 'views/partials/features/articlelink'

export default class ArticlesContainer extends Component<{
	related: {
		articles: Array<ArticleType>
	}
	featured_articles?: Array<ArticleType>
	mod?: string
	channel?: string
}> {
	view() {
		const {related, featured_articles, mod, channel} = this.attrs
		const featuredArticles = !featured_articles
			? []
			: featured_articles.filter(fa => !!fa.title)
		const relatedArticles =
			featuredArticles.length <= 1
				? related.articles
				: related.articles.slice(0, 2)
		const texts = this.getText(channel)
		return m('.articlescontainer', classes({mod}), [
			m('.articlescontainer-flex', [
				m(ContainerTitle, {
					className:
						'articlescontainer-flex-title' +
						(featuredArticles.length <= 1 ? '' : ' mod-short'),
					text: texts.title,
					mod
				}),
				m('.articlescontainer-flex-articles', [
					m('.articlescontainer-flex-articles-flex',
						{
							class:
								channel != 'homepage' && channel != undefined
									? 'mod-related'
									: ''
						},
						this.getArticles(relatedArticles)
					),
					featuredArticles.length > 0 &&
						m('.articlescontainer-featured', [
							featuredArticles.map(this.getFeatured)
						])
				])
			]),
			!mod &&
				m(Button,
					{mod: 'more arrow', ...action('/news?label=news')},
					texts.more
				)
		])
	}
	getArticles(articles: Array<ArticleType>) {
		return articles.slice(0, 3).map(article => m(ArticleLink, article))
	}
	getFeatured(featured_article: ArticleType) {
		return m(ArticleLink, {featured: true, ...featured_article})
	}
	getText(channel: string): {title: string; more: string} {
		let texts = {
			title: t('articles.relatednews'),
			more: t('articles.allnews')
		}
		switch (channel) {
			case 'homepage':
				texts.title = t('articles.latestnews')
				texts.more = t('articles.morenews')
				break
			case 'article':
			case 'event':
			case 'publication':
				texts.title = t('articles.relatedarticles')
				texts.more = t('articles.showmore')
				break
		}

		return texts
	}
}
